import { LOCAL_STORAGE_KEYS } from 'utils/local-storage';

export function getSelectedWarehouse() {
  const storedWarehouse = localStorage.getItem(
    LOCAL_STORAGE_KEYS.SELECTED_WAREHOUSE,
  );
  return storedWarehouse ? JSON.parse(storedWarehouse) : null;
}
